import { render, staticRenderFns } from "./NewMatter.vue?vue&type=template&id=2d7c7f54"
import script from "./NewMatter.vue?vue&type=script&lang=js"
export * from "./NewMatter.vue?vue&type=script&lang=js"
import style0 from "./NewMatter.vue?vue&type=style&index=0&id=2d7c7f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports